export default {
  registerDonationInGTM (donation) {
    let dataLayer = window.dataLayer || []
    dataLayer.push({
      'event': 'purchase',
      'currency': donation.currency,
      'transaction_id': donation.donation_id,
      'value': donation.sum,
      'items': [{
        'item_name': donation.month ? 'ежемесячно' : 'единоразово'
      }]
    })
  }
}
